var map = {
	"./banner-left.jpg.png": 8759,
	"./company_logo.png": 2503,
	"./en_US.png": 6272,
	"./icon.png": 7473,
	"./quality1_vn.png": 3015,
	"./quality2_vn.png": 7262,
	"./spacer.png": 2210,
	"./vi_VN.png": 6850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 196;